module.exports = __webpack_public_path__ + "img/plate_photo_2.97e7137d.jpg";